
  'use strict';

  /**
   * usage: <textarea ng-model="content" redactor></textarea>
   *
   *    additional options:
   *      redactor: hash (pass in a redactor options hash)
   *
   */
angular.module('angularRedactor', [])
  .directive("redactor", ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      require: "ngModel",
      link: function (scope, element, attrs, ngModel) {

        var updateModel = function updateModel(value) {
          scope.$apply(function () {
            ngModel.$setViewValue(value);  
          });
        },
        options = {
          //cleanup: false,
          deleted: true,
          linkEmail: true,
          linkAnchor: true,
          autoresize: false,
          minHeight: 300,
          convertDivs: false,
          changeCallback: updateModel,
          buttonsAdd: ["|","superscript", "subscript", "|", "id", "classes"],
          buttonsCustom: CustomRedactorButtons
        },
        additionalOptions = attrs.redactor ?
          scope.$eval(attrs.redactor) : {}, 
        editor;

        angular.extend(options, additionalOptions);

        // put in timeout to avoid $digest collision.  call render() to
        // set the initial value.
        $timeout(function () {
          editor = element.redactor(options);
          //editor.redactor('bufferSet'); //turn on buffer for undo of inserts
          //editor.redactor('observeStart'); //observe images and tables for editing/resizing
          ngModel.$render();
        });

        ngModel.$render = function () {
          if (angular.isDefined(editor)) {
            $timeout(function() {
              element.redactor('code.set', ngModel.$viewValue || '');
              element.redactor('observe.images');
            });
          }
        };
      }
    };
  }])


  .directive("redactormid", ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      require: "ngModel",
      link: function (scope, element, attrs, ngModel) {

        var updateModel = function updateModel(value) {
          scope.$apply(function () {
            ngModel.$setViewValue(value);
          });
        },
        options = {
          linkEmail: true,
          linkAnchor: true,
          autoresize: false,
          minHeight: 150,
          changeCallback: updateModel,
          buttons: ['bold', 'italic', 'deleted', 'link']
        },
        additionalOptions = attrs.redactor ?
          scope.$eval(attrs.redactor) : {}, editor;

        angular.extend(options, additionalOptions);

        // put in timeout to avoid $digest collision.  call render() to
        // set the initial value.
        $timeout(function () {
          editor = element.redactor(options);
          //editor.redactor('bufferSet'); //turn on buffer for undo of inserts
          //editor.redactor('observeStart'); //observe images and tables for editing/resizing
          ngModel.$render();
        });

        ngModel.$render = function () {
          if (angular.isDefined(editor)) {
            $timeout(function() {
              element.redactor('code.set', ngModel.$viewValue || '');
              element.redactor('observe.images');
            });
          }
        };
      }
    };
  }])


  .directive("redactormin", ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      require: "ngModel",
      link: function (scope, element, attrs, ngModel) {

        var updateModel = function updateModel(value) {
          scope.$apply(function () {
            ngModel.$setViewValue(value);
          });
        },
        options = {
          linkEmail: true,
          linkAnchor: true,
          autoresize: false,
          minHeight: 500,
          changeCallback: updateModel//,
          //buttons: ['bold', 'italic', 'deleted']
        },
        additionalOptions = attrs.redactor ?
          scope.$eval(attrs.redactor) : {}, editor;

        angular.extend(options, additionalOptions);

        // put in timeout to avoid $digest collision.  call render() to
        // set the initial value.
        $timeout(function () {
          editor = element.redactor(options);
          //editor.redactor('bufferSet'); //turn on buffer for undo of inserts
          //editor.redactor('observeStart'); //observe images and tables for editing/resizing
          ngModel.$render();
        });

        ngModel.$render = function () {
          if (angular.isDefined(editor)) {
            $timeout(function() {
              element.redactor('code.set', ngModel.$viewValue || '');
              element.redactor('observe.images');
            });
          }
        };
      }
    };
  }]);